import { COMPLIANCE_DUPLICATE_GROUP_BULK_TEMPLATE } from '../../../bulk-action-templates';
import type { ListBuilderList } from '../../../types';
import {
	duplicateAccountColumn,
	duplicateGroupColumn,
	duplicateLicenseColumn,
	duplicateOnFileColumn,
	reviewGroupActionColumn,
	shipToColumn,
	whyHereColumn,
} from '../columns';
import { hideOtherCardFilters } from '../filter-rules';
import { COMPLIANCE_ATTENTION_LIST_IDS } from '../list-ids';
import { DUPLICATE_GROUP_SORT_OPTIONS } from './duplicate-group-sort';

/**
 * Shared License (PD-16652, "Check Your Records") — one license on two or
 * more customer accounts (the Pharmsource ask: "a report of licenses so I can
 * identify if there are licenses attached to multiple accounts"). Only the
 * customer knows whether that is fine — a travelling veterinarian's own
 * license on several clinics — or a problem — a closed account beside the
 * account that replaced it — so every group with at least one open account is
 * listed and the customer marks it off.
 *
 * Riskiest first: a DEA number on accounts in two or more states; a closed
 * account beside an open one; no shared parent, address or name with two or
 * more accounts ordering; no shared parent, address or name; then the likely
 * fine (same parent account, same address, same name). Placeholder numbers
 * ("CLOSED", "bill to only", 123456) are not here: they are on Wrong Number
 * on File. NOT locked to active buyers: a closed account is often the finding.
 *
 * COUNT PARITY. As on Duplicate License: the locked `licenseSharedLicense:
 * yes` resolves to the member ids of the groups the dashboard card counts.
 */
export const sharedLicenseList: ListBuilderList = {
	id: COMPLIANCE_ATTENTION_LIST_IDS.sharedLicense,
	cacheTTL: 300000,
	name: 'Shared',
	type: 'default',
	active: true,
	// 15 is its Reviewed view.
	sortOrder: 15,
	filterRules: {
		...hideOtherCardFilters(['licenseSharedLicense']),
		licenseSharedLicense: {
			defaultValue: [{ id: 'yes', label: 'One license on several accounts' }],
			locked: true,
		},
	},
	columns: [
		duplicateGroupColumn,
		duplicateAccountColumn,
		shipToColumn,
		duplicateLicenseColumn,
		duplicateOnFileColumn,
		whyHereColumn,
		reviewGroupActionColumn,
	],
	sortOptions: DUPLICATE_GROUP_SORT_OPTIONS,
	defaultSortId: 'group-risk',
	// PD-16654: select several groups, record one outcome and note for all.
	bulkActionTemplate: COMPLIANCE_DUPLICATE_GROUP_BULK_TEMPLATE,
};
